<template>
    <div>
        <dashboard
        v-if="load"
      :activeaccounts="activeAccounts"
      :changerequest="changeRequest"
      :packagedata="packageData"
      :pendingapplications="pendingApplications"
      :networkdata="networkData"
      :networkspeeds="networkSpeeds"
      :unitspassed="unitsPassed"
      :unitsconnected="unitsConnected"
      :provisionedconnectionscount="provisionedConnections"
      :ispdata="ispData"
        ></dashboard>
    </div>
</template>
<script>
import Api from "@/services/Api";
import Dashboard from "@/components/fnoDashboardOneDevice.vue";
export default {
    components: {
        dashboard: Dashboard
    },
    data() {
    return {
      loadKey: 0,
      load: false,
      activeAccounts: [],
      changeRequest: [],
      packageData: [],
      pendingApplications: [],
      networkData: [],
      networkSpeeds: [],
      unitsPassed: {},
      unitsConnected: {},
      provisionedConnections: {},
      ispData: []
    };
  },
  async created() {
    this.initialize();
  },
    methods: {
         async initialize() {
      await this.getActiveAccounts();
      await this.getActiveChangeRequests();
      await this.getPendingApplications();
      await this.getLocationCount();
      await this.getConnectedLocationCount();
      await this.getProvisionedAccountsCount();
      await this.getServiceAccountBySpeed();
      this.loadKey += 1
      this.load = true
    },
    async getLocationCount(){
        await Api().get('/locations/active/count')
        .then(response=>{
            this.unitsPassed = response.data
        })
    },
    async getConnectedLocationCount(){
        await Api().get('/locations/connected/count')
        .then(response=>{
            this.unitsConnected = response.data
        })
    },
    async getProvisionedAccountsCount(){
        await Api().get('/deviceBridges/activeCount')
          .then(response=>{
              this.provisionedConnections = response.data
          })
    },
    async getActiveAccounts() {
      await Api()
        .get("/serviceAccounts/active/count/twodevice")
        .then(response => {
          this.activeAccounts = response.data;
        });
    },
    async getActiveChangeRequests() {
      await Api()
        .get("/changerequest/active/count")
        .then(response => {
          this.changeRequest = response.data;
        });
    },
    async getServiceAccountBySpeed() {
      await Api()
        .get("/serviceAccounts/allActive/speed/twodevice")
        .then(async response => {
          let speedProfiles = [
            ...new Set(
              response.data.map(
                item => item.packagesIsp.packagesFno.speedProfileId
              )
            )
          ];
          let ispArray = [
            ...new Set(
              response.data.map(
                item => item.packagesIsp.customerOrganisationId
              )
            )
          ];
          let networks = [
            ...new Set(
              response.data.map(
                item => item.location.locationNetworkId
              )
            )
          ];
          this.ispData = []
          await ispArray.map(e=>{
              let isp = response.data.find(x=>x.packagesIsp.customerOrganisation.id===e)
              this.ispData.push({
                  id: e,
                  customerOrganisation: isp.packagesIsp.customerOrganisation,
                  count: response.data.filter(f=>f.packagesIsp.customerOrganisationId === e).length
              })
          })
          this.ispData.sort((a, b) =>
            a.count < b.count
              ? 1
              : b.count < a.count
              ? -1
              : 0
          );
          this.packageData = [];
          await speedProfiles.map(x => {
            let find = response.data.find(
              z => z.packagesIsp.packagesFno.speedProfile.id === x
            );
            this.packageData.push({
              id: x,
              speedProfile: find.packagesIsp.packagesFno.speedProfile,
              count: response.data.filter(
                y => y.packagesIsp.packagesFno.speedProfileId === x
              ).length
            });
          });
          this.packageData.sort((a, b) =>
            a.speedProfile.downloadMbps > b.speedProfile.downloadMbps
              ? 1
              : b.speedProfile.downloadMbps > a.speedProfile.downloadMbps
              ? -1
              : 0
          );

          this.networkData = []

          await networks.map(x => {
            let find = response.data.find(
              z => z.location.locationNetwork.id === x
            );
            this.networkData.push({
              id: x,
              locationNetwork: find.location.locationNetwork,
              count: response.data.filter(
                y => y.location.locationNetworkId === x
              ).length
            });
          });
          
          this.networkData.sort((a, b) =>
            a.count < b.count
              ? 1
              : b.count < a.count
              ? -1
              : 0
          );

          this.networkSpeeds = []

          for (let a=0; a<this.packageData.length;a++){
              let color = await this.getRandomColors()
              let obj = {
                  speedProfileId: this.packageData[a].speedProfile.id,
                  label: this.packageData[a].speedProfile.name,
                  backgroundColor: color.background,
                  borderColor: color.border,
                  borderWidth: 1,
                  data: []
              }
              this.networkSpeeds.push(obj)
          }

          for (let b=0; b<this.networkData.length;b++){
              for (let c=0; c<this.networkSpeeds.length;c++){
                  let count = await response.data.filter(d=>d.location.locationNetworkId===this.networkData[b].locationNetwork.id&&
                  d.packagesIsp.packagesFno.speedProfileId===this.networkSpeeds[c].speedProfileId).length
                  await this.networkSpeeds[c].data.push(count)
              }
          }
        });
    },
    async getPendingApplications() {
      await Api()
        .get("/applications/pending/count")
        .then(response => {
          this.pendingApplications = response.data;
        });
    },
    async getRandomColors() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  let array = {background: '', border: ''}
//   for (let x=0; x<number; x++){
      for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  array.background = color
  array.border = this.pSBC(0.35, color)
  return array;
},
pSBC(p,c0,c1,l){
    let r,g,b,P,f,t,h,i=parseInt,m=Math.round,a=typeof(c1)=="string";
    if(typeof(p)!="number"||p<-1||p>1||typeof(c0)!="string"||(c0[0]!='r'&&c0[0]!='#')||(c1&&!a))return null;
    if(!this.pSBCr)this.pSBCr=(d)=>{
        let n=d.length,x={};
        if(n>9){
            [r,g,b,a]=d=d.split(","),n=d.length;
            if(n<3||n>4)return null;
            x.r=i(r[3]=="a"?r.slice(5):r.slice(4)),x.g=i(g),x.b=i(b),x.a=a?parseFloat(a):-1
        }else{
            if(n==8||n==6||n<4)return null;
            if(n<6)d="#"+d[1]+d[1]+d[2]+d[2]+d[3]+d[3]+(n>4?d[4]+d[4]:"");
            d=i(d.slice(1),16);
            if(n==9||n==5)x.r=d>>24&255,x.g=d>>16&255,x.b=d>>8&255,x.a=m((d&255)/0.255)/1000;
            else x.r=d>>16,x.g=d>>8&255,x.b=d&255,x.a=-1
        }return x};
    h=c0.length>9,h=a?c1.length>9?true:c1=="c"?!h:false:h,f=this.pSBCr(c0),P=p<0,t=c1&&c1!="c"?this.pSBCr(c1):P?{r:0,g:0,b:0,a:-1}:{r:255,g:255,b:255,a:-1},p=P?p*-1:p,P=1-p;
    if(!f||!t)return null;
    if(l)r=m(P*f.r+p*t.r),g=m(P*f.g+p*t.g),b=m(P*f.b+p*t.b);
    else r=m((P*f.r**2+p*t.r**2)**0.5),g=m((P*f.g**2+p*t.g**2)**0.5),b=m((P*f.b**2+p*t.b**2)**0.5);
    a=f.a,t=t.a,f=a>=0||t>=0,a=f?a<0?t:t<0?a:a*P+t*p:0;
    if(h)return"rgb"+(f?"a(":"(")+r+","+g+","+b+(f?","+m(a*1000)/1000:"")+")";
    else return"#"+(4294967296+r*16777216+g*65536+b*256+(f?m(a*255):0)).toString(16).slice(1,f?undefined:-2)
}
  }
  
    
}
</script>